var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8654 25.28C39.9563 24.8346 39.9985 24.4058 39.9998 24C40.0011 22.1504 39.1038 20.8 37.715 20.8C36.0229 20.8 34.2398 22.8058 33.7343 25.28C33.6434 25.7255 33.5999 26.1543 33.5999 26.56C33.5986 28.4096 34.4958 29.76 35.8846 29.76C37.5768 29.76 39.3585 27.7543 39.8654 25.28Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4847 13.1201C33.5525 12.7284 33.5896 12.3483 33.5986 11.9822C33.6511 9.70253 32.5925 8.00014 30.9721 8.00014C29.0918 8.00014 27.1679 10.2926 26.6764 13.1201C26.6073 13.5118 26.5715 13.892 26.5625 14.258C26.5087 16.5377 27.5686 18.2401 29.189 18.2401C31.0693 18.2401 32.9919 15.9476 33.4847 13.1201Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0013 22.0802C19.2871 22.0802 19.2155 27.2283 18.1428 28.5966C16.2843 30.9659 13.1675 32.5672 13.1214 35.9272C13.0843 38.6843 14.8123 40.0001 17.3057 40.0001C20.4788 40.0001 21.1905 38.0801 24.0013 38.0801C26.8109 38.0801 27.5226 40.0001 30.6957 40.0001C33.1891 40.0001 34.9171 38.6843 34.8799 35.9272C34.8339 32.5672 31.7171 30.9659 29.8586 28.5966C28.7859 27.2283 28.7155 22.0802 24.0013 22.0802Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1344 25.28C8.04352 24.8346 8.00128 24.4058 8 24C7.99872 22.1504 8.89599 20.8 10.2848 20.8C11.9769 20.8 13.7599 22.8058 14.2655 25.28C14.3564 25.7255 14.3999 26.1543 14.3999 26.56C14.4012 28.4096 13.5039 29.76 12.1152 29.76C10.423 29.76 8.64128 27.7543 8.1344 25.28Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5159 13.1201C14.4481 12.7284 14.411 12.3483 14.402 11.9822C14.3495 9.70253 15.4081 8.00014 17.0285 8.00014C18.9088 8.00014 20.8327 10.2926 21.3242 13.1201C21.3933 13.5118 21.4291 13.892 21.4381 14.258C21.4919 16.5377 20.432 18.2401 18.8116 18.2401C16.9313 18.2401 15.0087 15.9476 14.5159 13.1201Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetW);
export default __webpack_public_path__ + "static/media/pet-w.4e9fc21728236411ca7725a42aa3507d.svg";
export { ForwardRef as ReactComponent };